import {
    GET_DEBIT_NOTE_LISTING,
    GET_DEBIT_NOTE_LISTING_SUCCESS,
    GET_DEBIT_NOTE_LISTING_FAIL,
    GET_DEBIT_NOTE_DETAILS,
    GET_DEBIT_NOTE_DETAILS_SUCCESS,
    GET_DEBIT_NOTE_DETAILS_FAIL,
    RESET_DEBIT_NOTE_ACTION_STATE,
    RESET_DEBIT_NOTE_STATE,
    EXPORT_DEBIT_NOTE_FAIL,
    EXPORT_DEBIT_NOTE_SUCCESS,
    EXPORT_DEBIT_NOTE,
} from "./actionTypes";

export const getDebitNoteListing = (data) => ({
    type: GET_DEBIT_NOTE_LISTING,
    payload: data,
});

export const getDebitNoteListingSuccess = data => ({
    type: GET_DEBIT_NOTE_LISTING_SUCCESS,
    payload: data,
});

export const getDebitNoteListingFail = error => ({
    type: GET_DEBIT_NOTE_LISTING_FAIL,
    payload: error,
});

export const getDebitNoteDetails = data => ({
    type: GET_DEBIT_NOTE_DETAILS,
    payload: data,
});

export const getDebitNoteDetailsSuccess = data => ({
    type: GET_DEBIT_NOTE_DETAILS_SUCCESS,
    payload: data,
});

export const getDebitNoteDetailsFail = error => ({
    type: GET_DEBIT_NOTE_DETAILS_FAIL,
    payload: error,
});

export const getDebitNoteExport = data => ({
    type: EXPORT_DEBIT_NOTE,
    payload: data,
});

export const getDebitNoteExportSuccess = data => ({
    type: EXPORT_DEBIT_NOTE_SUCCESS,
    payload: data,
});

export const getDebitNoteExportFail = error => ({
    type: EXPORT_DEBIT_NOTE_FAIL,
    payload: error,
});

//reset
export const resetDebitNoteActionState = () => {
    return {
        type: RESET_DEBIT_NOTE_ACTION_STATE,
    }
}
export const resetDebitNoteState = () => {
    return {
        type: RESET_DEBIT_NOTE_STATE,
    }
}

